export const SIZE = 20

